import type { ICountryObject } from "app/services/CountryService";

import type Signal from "../core/Signal";
import type SignalFilters from "../core/SignalFilters";
import type SignalTemplate from "./SignalTemplate";

export default abstract class SignalTemplatesManager<Filters extends SignalFilters> {
    constructor(protected readonly countries: readonly ICountryObject[]) {}

    matchSignal(signal: Signal<Filters>): SignalTemplate<Filters> | undefined {
        return this.getTemplates().find((template) => template.matchesSignal(signal));
    }

    abstract getTemplates(): readonly SignalTemplate<Filters>[];

    abstract getEmptyTemplate(): Readonly<SignalTemplate<Filters>>;

    abstract getDefaultTemplate(): Readonly<SignalTemplate<Filters>>;
}
